import { useEffect, useContext } from "react";
import { UserContext } from "../../Context/UserContext";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const { logout } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    localStorage.clear();
    navigate("/");
  }, [logout, navigate]);

  return null;
};

export default Logout;
